import SectionHeading from "./SectionHeading";
import { uncutMovies } from "@/mocks/home";
import type { MovieDetail } from "../types";

interface UncutSectionProps {
  onOpen: (movie: MovieDetail) => void;
  onNotify: (message: string) => void;
}

export default function UncutSection({ onOpen, onNotify }: UncutSectionProps) {
  return (
    <section id="uncut" className="w-full border-y border-background-300/40 bg-background-100/40">
      <div className="mx-auto w-full max-w-[1180px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          index="04"
          eyebrow="无删减版"
          title="无删减版专区"
          desc="完整版、导演剪辑、加长与原始版本集中收录，关键段落一段不落，入口都放在最顺手的位置。"
        />

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {uncutMovies.map((movie) => (
            <article
              key={movie.id}
              className="flex flex-col rounded-lg border border-background-300/50 bg-background-50 p-5 transition-colors hover:border-accent-500/40"
            >
              <div className="flex items-center justify-between gap-2">
                <span className="rounded-full border border-accent-500/40 bg-accent-500/10 px-2.5 py-0.5 text-[11px] text-accent-300">
                  {movie.badge}
                </span>
                <span className="font-label text-sm text-foreground-500">{movie.duration}</span>
              </div>
              <h3 className="mt-3 font-display text-base font-bold text-foreground-950">{movie.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-500">{movie.note}</p>
              <div className="mt-4 flex items-center gap-2">
                <button
                  type="button"
                  onClick={() =>
                    onOpen({
                      title: movie.title,
                      duration: movie.duration,
                      badge: movie.badge,
                      summary: movie.note,
                      tags: [movie.badge, "无删减"],
                    })
                  }
                  className="flex flex-1 cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-play-fill" />
                  完整观看
                </button>
                <button
                  type="button"
                  onClick={() => onNotify(`《${movie.title}》已加入下载队列`)}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300/60 text-foreground-600 transition-colors hover:border-accent-400 hover:text-accent-300"
                  aria-label="下载"
                >
                  <i className="ri-download-2-line" />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}